import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [
  // 前台页面
  {path: '/', name: '羽诗一物一码', component: resolve => require(['@/pages/index/Index.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/categoryList/:id', name: '分类信息', component: resolve => require(['@/pages/index/categoryList'], resolve),meta: {noNeedLogin: true}},
  {path: '/goodsInfo/:id', name: '商品详情', component: resolve => require(['@/pages/index/goodsInfo.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/source', name: '溯源信息', component: resolve => require(['@/pages/index/source.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/goodsShare/:id', name: '我要分享', component: resolve => require(['@/pages/index/goodsShare.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/buy', name: '购买商品', component: resolve => require(['@/pages/index/buy.vue'], resolve)},
  {path: '/payment', name: '在线支付', component: resolve => require(['@/pages/index/payment.vue'], resolve)},
  {path: '/success', name: '付款成功', component: resolve => require(['@/pages/index/success.vue'], resolve)},
  {path: '/fail', name: '付款失败', component: resolve => require(['@/pages/index/fail.vue'], resolve)},
  {path: '/userRanking', name: '用户佣金排行', component: resolve => require(['@/pages/index/userRanking.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/ranking', name: '商品奖励金排行', component: resolve => require(['@/pages/index/ranking.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/merchantRegister', name: '商户申请', component: resolve => require(['@/pages/index/merchantRegister.vue'], resolve)},
  {path: '/login', name: '用户密码登录', component: resolve => require(['@/pages/login/Login.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/loginMobile', name: '手机验证码登录', component: resolve => require(['@/pages/login/loginMobile.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/search', name: '搜索', component: resolve => require(['@/pages/index/search.vue'], resolve),meta: {noNeedLogin: true}},
  {path: '/help', name: '帮助信息', component: resolve => require(['@/pages/index/help.vue'], resolve),meta: {noNeedLogin: true}},
	{path: '/helpInfo/:id',name:'平台介绍',component:resolve=>require(['@/pages/index/helpInfo.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/ywymInfo',name:'一物一码介绍',component:resolve=>require(['@/pages/index/ywymInfo.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/exchange',name:'E豆兑换大厅',component:resolve=>require(['@/pages/index/exchange.vue'],resolve),},
  {path: '/exchangeShop/:id',name:'兑换商品',component:resolve=>require(['@/pages/index/exchangeShop.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/mallRebate',name:'商城返利',component:resolve=>require(['@/pages/index/mallRebate.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/moreProducts',name:'更多产品',component:resolve=>require(['@/pages/index/moreProducts.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/activityHall',name:'活动大厅',component:resolve=>require(['@/pages/index/activityHall.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/videoTutorial',name:'视频教程',component:resolve=>require(['@/pages/index/videoTutorial.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/taobao',name:'淘宝优惠劵',component:resolve=>require(['@/pages/index/taobao.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/tmall',name:'天猫优惠劵',component:resolve=>require(['@/pages/index/tmall.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/jd',name:'京东优惠劵',component:resolve=>require(['@/pages/index/jd.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/product',name:'产品页面',component:resolve=>require(['@/pages/index/product.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/taobao_detail/:id',name:'商品详情[淘宝]',component:resolve=>require(['@/pages/index/taobao_detail.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/pdd_detail/:id',name:'商品详情[拼多多]',component:resolve=>require(['@/pages/index/pdd_detail.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/jd_detail/:id',name:'商品详情[京东]',component:resolve=>require(['@/pages/index/jd_detail.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/tmall_detail/:id',name:'商品详情[天猫]',component:resolve=>require(['@/pages/index/tmall_detail.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/pdd',name:'拼多多优惠劵',component:resolve=>require(['@/pages/index/pdd.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/pdd_theme',name:'拼多多主题活动',component:resolve=>require(['@/pages/index/pdd_theme.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/theme_goods/:id',name:'拼多多主题商品',component:resolve=>require(['@/pages/index/theme_goods.vue'],resolve),meta:{noNeedLogin:true}},
  {path: '/appdownload',name:'羽诗一物一码APP下载',component:resolve=>require(['@/pages/index/appdownload.vue'],resolve),meta:{noNeedLogin:true}},
  
  

 
  



  



  // 个人中心页面
  {path: '/user/index', name: '个人中心', component: resolve => require(['@/pages/user/index.vue'], resolve)},
  {path: '/user/order', name: '我的订单', component: resolve => require(['@/pages/user/order.vue'], resolve)},
  {path: '/user/orderDetail/:id', name: '订单详情', component: resolve => require(['@/pages/user/orderDetail.vue'], resolve)},
  {path: '/user/myShare', name: '我的分享', component: resolve => require(['@/pages/user/myShare.vue'], resolve)},
  {path: '/user/myCommission', name: '我的佣金', component: resolve => require(['@/pages/user/myCommission.vue'], resolve)},
  {path: '/user/myCollection', name: '我的收藏', component: resolve => require(['@/pages/user/myCollection.vue'], resolve)},
  {path: '/user/myComment', name: '我的评论', component: resolve => require(['@/pages/user/myComment.vue'], resolve)},
  {path: '/user/commentDetail/:id', name: '评论详情', component: resolve => require(['@/pages/user/commentDetail.vue'], resolve)},
  {path: '/user/commentAdd/:id', name: '我要评论', component: resolve => require(['@/pages/user/commentAdd.vue'], resolve)},
  {path: '/user/notice', name: '信息中心', component: resolve => require(['@/pages/user/notice.vue'], resolve)},
  {path: '/user/goodsCanReturn', name: '可申请售后', component: resolve => require(['@/pages/user/goodsCanReturn.vue'], resolve)},
  {path: '/user/goodsReturnProgress', name: '退换货列表', component: resolve => require(['@/pages/user/goodsReturnProgress.vue'], resolve)},
  {path: '/user/returnGoods/:id', name: '申请售后服务', component: resolve => require(['@/pages/user/returnGoods.vue'], resolve)},
  {path: '/user/returnGoodsInfo', name: '申请售后服务单详情', component: resolve => require(['@/pages/user/returnGoodsInfo.vue'], resolve)},




  //商户页面
  {path: '/seller/index', name: '商户首页', component: resolve => require(['@/pages/seller/index.vue'], resolve)},
  {path: '/seller/storeSetting', name: '店铺设置', component: resolve => require(['@/pages/seller/storeSetting.vue'], resolve)},
  {path: '/seller/storeMsg', name: '系统信息', component: resolve => require(['@/pages/seller/storeMsg.vue'], resolve)},
  {path: '/seller/goods', name: '商品列表', component: resolve => require(['@/pages/seller/goods.vue'], resolve)},
  {path: '/seller/goodsAddEdit', name: '添加修改商品', component: resolve => require(['@/pages/seller/goodsAddEdit.vue'], resolve)},
  {path: '/seller/publishSuccess', name: '商品发布成功', component: resolve => require(['@/pages/seller/publishSuccess.vue'], resolve)},
  {path: '/seller/goodsInfo', name: '商品详情', component: resolve => require(['@/pages/seller/goodsInfo.vue'], resolve)},
  {path: '/seller/order', name: '订单管理', component: resolve => require(['@/pages/seller/order.vue'], resolve)},
  {path: '/seller/orderDetail', name: '订单详情', component: resolve => require(['@/pages/seller/orderDetail.vue'], resolve)},
  {path: '/seller/goodsComment', name: '商品评论列表', component: resolve => require(['@/pages/seller/goodsComment.vue'], resolve)},
  {path: '/seller/commentDetail', name: '评论详情', component: resolve => require(['@/pages/seller/commentDetail.vue'], resolve)},
  {path: '/seller/freight', name: '运费模板列表', component: resolve => require(['@/pages/seller/freight.vue'], resolve)},
  {path: '/seller/freightAddEdit', name: '编辑运费模板', component: resolve => require(['@/pages/seller/freightAddEdit.vue'], resolve)},
  {path: '/seller/freightAddNew', name: '新增运费模板', component: resolve => require(['@/pages/seller/freightAddNew.vue'], resolve)},
  {path: '/seller/freightSelectArea', name: '选择地区', component: resolve => require(['@/pages/seller/freightSelectArea.vue'], resolve)},
  {path: '/seller/withdrawals', name: '提现申请列表', component: resolve => require(['@/pages/seller/withdrawals.vue'], resolve)},
  {path: '/seller/wthdrawalsAddEdit', name: '申请/编辑提现', component: resolve => require(['@/pages/seller/wthdrawalsAddEdit.vue'], resolve)},
  {path: '/seller/orderStatis', name: '结算订单列表', component: resolve => require(['@/pages/seller/orderStatis.vue'], resolve)},
  {path: '/seller/orderStatisList', name: '结算记录', component: resolve => require(['@/pages/seller/orderStatisList.vue'], resolve)},
  {path: '/seller/refundList', name: '退款退货', component: resolve => require(['@/pages/seller/refundList.vue'], resolve)},
  {path: '/seller/refundInfo', name: '退款退货详情及处理', component: resolve => require(['@/pages/seller/refundInfo.vue'], resolve)},
  {path: '/seller/returnList', name: '换货', component: resolve => require(['@/pages/seller/returnList.vue'], resolve)},
  {path: '/seller/returnInfo', name: '换货详情及处理', component: resolve => require(['@/pages/seller/returnInfo.vue'], resolve)},
  {path: '/seller/saleTop', name: '销售排行', component: resolve => require(['@/pages/seller/saleTop.vue'], resolve)},
  {path: '/seller/finance', name: '运营统计', component: resolve => require(['@/pages/seller/finance.vue'], resolve)},



  
]

const router = new Router({
  routes: routes
})

function getCookie(cname) {
  let name = cname + "=";
  var ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

router.beforeEach((to, from, next) => {
  // 修改页面title
  if (to.name) {
    document.title = to.name
  }
  let isLogin = getCookie('token');
  // 判断该路由是否需要登录权限
  if (!to.meta.noNeedLogin) {
    let localToken = window.localStorage.getItem('token')
    if (localToken) {
      next()
    } else {
      if(isLogin){
        window.localStorage.setItem("token", isLogin);
        next();
      }else{
        router.push({ path: '/login' })
      }
    }
  } else {
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js